export default __webpack_public_path__ + "downArrowSelect-tWV.svg";